'use client';

import { useMemo } from 'react';
import { useI18n } from 'next-localization';

import { NeuSelect } from '@hcahealthcaredpx/neutron-react';

import { ALL_FACILITY_OPTION } from '../../constants';
import { useListingContext } from '../../hooks';

export const FacilitiesFilter = (): JSX.Element | null => {
  const { t } = useI18n();

  const { facilities, setSelectedFacility, selectedFacility } = useListingContext();

  const items = useMemo(() => {
    const facilitiesWithAll = [ALL_FACILITY_OPTION, ...(facilities || [])];
    return facilitiesWithAll.map(({ coid, locationUrlTitle, facilityName }) => ({
      value: locationUrlTitle ? `${coid}|${locationUrlTitle}` : coid,
      label: facilityName,
    }));
  }, [facilities]);

  const selectedValue = useMemo(
    () => items?.find((item) => item.value === selectedFacility),
    [items, selectedFacility]
  );

  return (
    <NeuSelect
      items={items}
      label={t('OAS.Listing.Filters.Facility')}
      value={selectedValue}
      onNeuChange={(e) => setSelectedFacility(e.value)}
      required
    />
  );
};
